import React from "react"

import { SupporterSelect, TeamMemberSelect } from "@/components"
import { ASSIGNMENT_SECTION_USER_TOOLTIP, ASSIGNMENT_SECTION_SUPPORTER_TOOLTIP } from "shared/imports/sharedConstants"

export const AssignmentFormSection = () => {
    return (
        <>
            <TeamMemberSelect
                label="Team Members"
                name="assignmentsTeamMembers"
                tooltip={ASSIGNMENT_SECTION_USER_TOOLTIP}
            />
            <SupporterSelect
                name="assignmentsSupporters"
                label="Contacts"
                tooltip={ASSIGNMENT_SECTION_SUPPORTER_TOOLTIP}
            />
        </>
    )
}
